var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"container bg-black m-auto text-white text-center text-xs p-2"},[_vm._v(" All rights reserved. ©"+_vm._s(_vm.currentYear)+" Straight Scrum LLC. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }